import { useState } from 'react'
import {
  copyToClipboard,
  facebookSharerLink,
  linkedinSharerLink,
  twitterSharerLink,
} from '../../helpers/sharer'
import { Clipboard, X, Facebook, Linkedin, TwitterX } from 'react-bootstrap-icons'
import { Images } from '../../assets/images'

enum SocialMediaType {
  twitter = 'twitter',
  linkedin = 'linkedin',
  facebook = 'facebook',
}

export const SocialShareModal = ({
  shareUrl,
  onClose,
}: {
  shareUrl?: string
  onClose: () => void
}) => {
  const [message, setMessage] = useState('')
  const [socialMediaSelected, setSetSocialMediaSelected] =
    useState<SocialMediaType>(SocialMediaType.twitter)
  const [showCopiedMessage, setShowCopiedMessage] = useState(false)

  const fullShareUrl =
    shareUrl || (typeof window !== 'undefined' ? window.location.href : '')

  const onShare = () => {
    let baseSocialUrl: string | null = null

    switch (socialMediaSelected) {
      case SocialMediaType.twitter:
        baseSocialUrl = twitterSharerLink(fullShareUrl, message)
        break
      case SocialMediaType.linkedin:
        baseSocialUrl = linkedinSharerLink(fullShareUrl)
        break
      case SocialMediaType.facebook:
        baseSocialUrl = facebookSharerLink(fullShareUrl)
        break
      default:
        console.info('Social media type is invalid')
        break
    }

    if (!baseSocialUrl) return

    const newWindow = window.open(baseSocialUrl, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  return (
    <div className="osirus-social-modal-overlay">
      <div className="osirus-social-modal-container">
        <div className="osirus-social-modal-header">
          <div className="osirus-social-modal-header-social-options">
            <button
              onClick={() => setSetSocialMediaSelected(SocialMediaType.twitter)}
              className={
                socialMediaSelected === SocialMediaType.twitter
                  ? 'osirus-social-modal-header-social-options-active'
                  : undefined
              }
            >
              <TwitterX />
            </button>

            <button
              onClick={() => setSetSocialMediaSelected(SocialMediaType.linkedin)}
              className={
                socialMediaSelected === SocialMediaType.linkedin
                  ? 'osirus-social-modal-header-social-options-active'
                  : undefined
              }
            >
              <Linkedin />
            </button>

            <button
              onClick={() => setSetSocialMediaSelected(SocialMediaType.facebook)}
              className={
                socialMediaSelected === SocialMediaType.facebook
                  ? 'osirus-social-modal-header-social-options-active'
                  : undefined
              }
            >
              <Facebook />
            </button>
          </div>

          <button
            onClick={onClose}
            className="osirus-social-modal-header-close-button"
          >
            <X />
          </button>
        </div>

        <div className="osirus-social-modal-content">
          <img src={Images.personDark} alt="Person Icon" />
          <textarea
            name="message"
            placeholder="Type your message"
            onChange={(event) => setMessage(event.target.value)}
            value={message}
          />
        </div>

        <div className="osirus-social-modal-footer">
          <button
            onClick={() => {
              copyToClipboard(fullShareUrl)
              setShowCopiedMessage(true)
              setTimeout(() => setShowCopiedMessage(false), 2500)
            }}
            disabled={!fullShareUrl}
          >
            <Clipboard />
            Copy URL
            {showCopiedMessage && (
              <span className="osirus-copied-message">Copied!</span>
            )}
          </button>

          <button onClick={onShare} disabled={!fullShareUrl}>
            Share
          </button>
        </div>
      </div>
    </div>
  )
}
